import { SEARCH_BIKE_VARIANT_REQUEST, SEARCH_BIKE_VARIANT_REQUEST_SUCCESS, SEARCH_BIKE_VARIANT_REQUEST_FAILURE } from '../../../../PlatformManagement/BikeManagement/redux/constants/bike_model.constants';

export const searchBikeVariantRequest = (model_id, value) => ({ type: SEARCH_BIKE_VARIANT_REQUEST, model_id, value });
export const searchBikeVariantRequestSuccess = payload => ({ type: SEARCH_BIKE_VARIANT_REQUEST_SUCCESS, payload });
export const searchBikeVariantRequestFailure = error => ({ type: SEARCH_BIKE_VARIANT_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/search_by_variants.actions.js